import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.798 2.69c.019-1.683-2.285-2.178-2.958-.636L6.13 12.84A1.543 1.543 0 0 0 7.546 15h3.145l-.154 6.298c-.042 1.682 2.255 2.207 2.949.674l1.051-2.325 1.594-3.744 2.146-4.72A1.543 1.543 0 0 0 16.871 9h-3.145z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_electric_filled-BaneSnjp.js.map
